// Module
var code = `<template>
  <require from="./mandat-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>
  <!-- beautify ignore:start -->
  <style>
    .mandat-widget-\${id} td {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
    }

    .mandat-widget-\${id} th {
      font-family: \${headerFont ? headerFont : 'var(--dyn-default-font-family)'};
      font-size: \${headerFontSize ? headerFontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${headerColor | widgetTemplateColor:isInDashboard} !important;
    }
  </style>
  <!-- beautify ignore:end -->

  <div if.bind="!loading && !error" class="mandat-widget mandat-widget-\${id}" ref="widgetDiv">
    <table>
      <thead>
        <tr>
          <th>Inndeling</th>
          <th class="mandat-widget__numeric">Faktisk</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="d of data">
          <td>\${d.group}</td>
          <td class="mandat-widget__numeric">
            \${d.estimatedValuePercent | numericFormatter:'0'}%
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <message if.bind="error" icon="error" colour="mdc-theme--error" class="mandat-widget__error">
    \${error.message}</message>
</template>
`;
// Exports
export default code;